export const isBrowserEyeDropper = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!window.EyeDropper) return false;
  return true;
};
